import { MELOGY_BLACK, MELOGY_WHITE } from '../style/colors'
import { TbMetronome } from "react-icons/tb";
import { VscSymbolStructure } from "react-icons/vsc";
import { GiGClef } from "react-icons/gi";
import { ReactComponent as TuningForkIcon } from "../style/icons/tuningFork.svg"
import { ReactComponent as HistogramIcon } from "../style/icons/histogram.svg"
import { ReactComponent as ContrastIcon } from "../style/icons/contrast.svg"
import { PiPianoKeys } from "react-icons/pi";
import { 
    FaGuitar, 
    FaPalette 
} from "react-icons/fa";

export const findFarthestColor = (givenColor) => {
    if (!givenColor) {
        return;
    }
    const [a] = parseRGBA(givenColor);
    
    if (a < 0.5) {
        return "white";
    }

    const distances = {
        black: calculateDistance(givenColor, MELOGY_BLACK),
        white: calculateDistance(givenColor, MELOGY_WHITE),
    };

    return Object.keys(distances).reduce((farthest, color) =>
        distances[color] > distances[farthest] ? color : farthest
    );
}

export const parseRGBA = (rgbaColor) => {
    return rgbaColor
        .replace(/^rgba?\(|\s+|\)$/g, "")
        .split(",")
        .map(Number);
}

export const calculateDistance = (color1, color2) => {
    const [r1, g1, b1] = parseRGBA(color1);
    const [r2, g2, b2] = parseRGBA(color2);

    return Math.sqrt(
        Math.pow(r2 - r1, 2) +
        Math.pow(g2 - g1, 2) +
        Math.pow(b2 - b1, 2)
    );
}

export const getStyleColor = (style) => {
    if (!style) {
        return;
    }

    const colorItem = style.find((item) => item.name === "color");

    if (!colorItem) {
        return;
    }

    return colorItem.value;
}

export const getStyleBackgroundImage = (style) => {
    if (!style) {
        return null;
    }

    const backgroundImageItem = style.find((item) => item.name === "backgroundImage");

    if (!backgroundImageItem || !backgroundImageItem.value || backgroundImageItem.value.trim() === "") {
        return null;
    }

    return backgroundImageItem.value;
}

export const getSelectedStyleColor = (selectedStyle, alpha) => {
    if (!selectedStyle) {
        return `rgba(0, 0, 0, ${alpha})`; 
    }

    const colorItem = selectedStyle.find((item) => item.name === "color");
    if (!colorItem || !colorItem.value) {
        return `rgba(0, 0, 0, ${alpha})`;
    }

    const color = colorItem.value; 
    
    const [r, g, b, a] = color
        .replace(/^rgba?\(|\s+|\)$/g, "")
        .split(",") 
        .map(Number);

    return `rgba(${r}, ${g}, ${b}, ${alpha !== undefined ? alpha : a})`; 
};

export const getSlightlyDarkerColor = (selectedStyle, alpha) => {
    if (!selectedStyle) {
        return `rgba(0, 0, 0, ${alpha})`; 
    }

    const colorItem = selectedStyle.find((item) => item.name === "color");
    if (!colorItem || !colorItem.value) {
        return `rgba(0, 0, 0, ${alpha})`;
    }

    const color = colorItem.value; 

    const [r, g, b, a] = color
        .replace(/^rgba?\(|\s+|\)$/g, "")
        .split(",")
        .map(Number);

    const darkerR = Math.max(0, Math.floor(r * 0.3));
    const darkerG = Math.max(0, Math.floor(g * 0.3));
    const darkerB = Math.max(0, Math.floor(b * 0.3));

    return `rgba(${darkerR}, ${darkerG}, ${darkerB}, ${alpha !== undefined ? alpha : a})`; 
};

export const getIcon = (type, color) => {
    const iconSize = { fontSize: "22px" };

    const icons = {
        Tempo: <TbMetronome style={iconSize} />,
        Form: <VscSymbolStructure style={iconSize} />,
        Key: <GiGClef style={iconSize} />,
        Chord: <PiPianoKeys style={iconSize} />,
        Instruments: <FaGuitar style={iconSize} />, 
        "Misc.": <TuningForkIcon style={{ width: "22px", height: "22px", fill: color }} />,
        Repetition: <HistogramIcon style={{ width: "22px", height: "22px", fill: color }} />,
        Extensions: <PiPianoKeys style={iconSize} />,
        Quality: <ContrastIcon style={{ width: "22px", height: "22px", fill: color }} />, 
        Background: <FaPalette style={iconSize} />,
        Color: <FaPalette style={iconSize} />,
        Tuning: <TuningForkIcon style={{ width: "22px", height: "22px", fill: color }} />,
    };

    return icons[type] || null;
};